export const FS_EVENTS = {
  POPUP_CLOSE: 'POPUP_CLOSE',
  DATA_UPDATE: 'DATA_UPDATE',
}

export const FS_SESSION_KEY = 'FS_DATA'
